import { fetchDocumentProcesses, updateDocumentProcess } from '@/api/document-processes.api';
import type { IGetDocumentProcessesParams, IUpdateDocumentProcessParams } from '@condo/domain';
import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { type MaybeRef, computed, unref } from 'vue';

export const useDocumentProcesses = (paramsOrRef: MaybeRef<IGetDocumentProcessesParams>) => {
    const params = computed(() => unref(paramsOrRef));
    const enabled = computed(() => !!params.value.entity && !!params.value.entityId);

    return useQuery(['document-processes', params.value.entity, params.value.entityId], () => fetchDocumentProcesses(params.value), {
        initialData: [],
        enabled,
    });
};

export const useUpsertDocumentProcess = () => {
    const queryClient = useQueryClient();
    return async (params: IUpdateDocumentProcessParams) => {
        const result = await updateDocumentProcess(params);
        queryClient.setQueryData(['document-processes', params.entity, params.entityId], result);
        return result;
    };
};
